import {
  GridContainer,
  GridItem,
  GridRow,
  gridConfig,
} from "@tvg/fuse-responsive-grid";
import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  gap: var(--spacing-space8);

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    gap: var(--spacing-space4);
  }
`;

export const StyledProductsItem = styled(GridItem)``;

export const StyledProductsContainer = styled(GridContainer)`
  && {
    width: 100%;
    padding: 0;
  }
`;

export const StyledGridRow = styled(GridRow)``;
